import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-using-sources',
  templateUrl: './using-sources.component.html',
  styleUrls: ['./using-sources.component.scss']
})
export class UsingSourcesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
